const getOtherFonts = fonts => {
  const { otherFonts = {} } = fonts;
  return Object.keys(otherFonts).map(key => otherFonts[key]);
};

export default getOtherFonts;
